import Axios from "@/plugins/Axios";
import GestaoDeAula from "@/Models/GestaoDeAula";
import Aula from "@/Models/Aula";

export class GestoesDeAulasAuxiliaresService {
  async syncAll(pageNumber, query) {
    const response = await Axios().get(
      `gestoes-de-aulas-auxiliares?page=${pageNumber}&query=${query}`
    );

    return response.data;
  }

  async listarAulasGestao(gestaoDeAulaId) {
    const response = await Axios().post("gestoes-de-aulas-auxiliares/listar-aulas-gestao", {
      gestao_id: gestaoDeAulaId,
    });
    const aulas = response.data.gestaoDeAula.aulas.map((aulas) => new Aula(aulas));
    const payload = response.data;
    return { aulas, payload };
  }

  async visualizar(gestaoDeAula) {
    const response = await Axios().get(`gestoes-de-aulas-auxiliares/${gestaoDeAula}/visualizar`);
    return response.data;
  }

  async visualizarTurma(gestaoDeAula) {
    const response = await Axios().get(
      `gestoes-de-aulas-auxiliares/${gestaoDeAula}/visualizar/turma`
    );
    return response.data;
  }

  async gestaoGeralId(gestaoDeAulaId) {
    const filtro = true;
    const response = await Axios().get(
      `gestoes-de-aulas-auxiliares/${gestaoDeAulaId}/visualizar/${filtro}`
    );
    return response.data;
  }

  async geral() {
    const response = await Axios().get(`gestoes-de-aulas-auxiliares/geral`);
    const gestoesDeAulasGeral = response.data.map(
      (gestaoDeAulas) => new GestaoDeAula(gestaoDeAulas)
    );

    return gestoesDeAulasGeral;
  }

  async geralPaginate(pageNumber, query) {
    const response = await Axios().get(
      `gestoes-de-aulas-auxiliares/geral?page=${pageNumber}&query=${query}`
    );

    return response.data;
  }

  async listarGestoesProfessor(gestao) {
    const response = await Axios().post(`gestoes-de-aulas-auxiliares/listar-gestoes-professor`, {
      gestao: {
        id: gestao?.id,
        instrutor_id: gestao?.instrutor_id,
        disciplina_id: gestao?.disciplina_id,
        turma: {
          id: gestao?.turma?.id,
          series: (gestao?.turma?.series ?? []).map((serie) => ({ id: serie.id })),
        },
      },
    });
    return response.data;
  }

  async listarGestaoDeAulasDaTurma(turma_id) {
    const response = await Axios().post(`gestoes-de-aulas-auxiliares/listar-gestoes-aulas-turma`, {
      turma_id,
    });
    return response.data;
  }

  async criar(relacoesList) {
    const response = await Axios().post("gestoes-de-aulas-auxiliares", relacoesList);
    return response.data;
  }

  async atualizar(gestaoDeAulas) {
    const response = await Axios().put(
      `gestoes-de-aulas-auxiliares/${gestaoDeAulas.id}`,
      gestaoDeAulas
    );
    const gestaoDeAulasAtualizada = response.data;
    return gestaoDeAulasAtualizada;
  }

  async deletarGestaoDeAula(gestaoDeAulas) {
    const response = await Axios().delete(
      `gestoes-de-aulas-auxiliares/deletar-gestao/${gestaoDeAulas.id}`
    );
    const gestaoDeAulasDeletada = response.data;
    return gestaoDeAulasDeletada;
  }

  async editarGestaoDeAula(gestaoDeAulas) {
    const response = await Axios().edit(
      `gestoes-de-aulas-auxiliares/visualizar/${gestaoDeAulas.id}`
    );
    const gestaoDeAulasEditada = response.data;
    return gestaoDeAulasEditada;
  }

  async recuperarGestaoDeAula(gestaoDeAulas) {
    return this.atualizarGestaoDeAula({ ...gestaoDeAulas, deleted_at: null });
  }

  async historicoAulasLancadas(gestaoDeAulaId) {
    const response = await Axios().get(
      `gestoes-de-aulas-auxiliares/historico-aulas-lancadas/${gestaoDeAulaId}`
    );
    return response.data;
  }

  async historicoPlanosLancados(gestaoDeAulaId, bimestre) {
    const response = await Axios().get(
      `gestoes-de-aulas-auxiliares/historico-planos-lancados/${gestaoDeAulaId}/${bimestre}`
    );
    return response.data;
  }

  async listarDisciplinas(idGestao) {
    const response = await Axios().get(`listar-disciplinas/${parseInt(idGestao, 10)}`);
    return response;
  }

  async listarPerguntas(idDisciplina, gestao, mes_id) {
    const response = await Axios().get(
      `gestoes-de-aulas-auxiliares/listar-perguntas/${parseInt(
        idDisciplina,
        10
      )}/${gestao}/${mes_id}`
    );
    return response;
  }

  async salvar(form, disciplina, gestao, mes_id) {
    const response = await Axios().post(
      `gestoes-de-aulas-auxiliares/salvar/${disciplina}/${gestao}/${mes_id}`,
      { form }
    );
    return response;
  }
}

export default new GestoesDeAulasAuxiliaresService();
